import React, { useEffect } from 'react'
import { isEmpty } from 'libraries/lodash'
import dayjs from 'dayjs'
import Grid from '@material-ui/core/Grid'
import url from 'front-end-core/core/url'
import { SEARCH } from 'constants/controllers'
import caSortOptions from 'constants/caSortOptions'
import SearchTypeButtonContainer from 'redux/containers/components/search/SearchTypeButtonContainer'
import SortBy from 'components/search/SortBy'
import QuickDatePickers from 'components/search/CAQuickDatePickers'
import CalenderDatePickers from 'components/shared/calender-date-pickers'
import { pushEvent } from 'services/AnalyticsService'
import { replaceUrl } from 'front-end-core/core/history'
import useDatePicker from 'hooks/useDatePicker'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import SearchFilters from 'components/search/SearchFilters'
import PrecedentsSearchFilters from 'components/search/PrecedentsSearchFilters'
import useMenu from 'hooks/useMenu'
import selectSearchMenu from 'redux/selectors/selectSearchMenu'

dayjs.locale('en')

const Facets = ({ response, setFacetsPaginationMode, pageNumber, ...props }) => {
  useEffect(() => {
    setFacetsPaginationMode && setFacetsPaginationMode(pageNumber > 0 ? 'paged' : 'all')
  }, [setFacetsPaginationMode, pageNumber])

  return (
    <ResponseConsumer
      baddataComponent={null}
      badresponseComponent={null}
      content={() => <FacetsContent {...props} facets={response.facets} flatFacets={response.flatFacets} />}
      offlineComponent={null}
      response={response}
    />
  )
}

export default Facets

const FacetsContent = (props) => (
  <div className='ph6'>
    <h2 className='mb7 f4 b black lh-title'>
      Search type
    </h2>
    <Grid container className='mb7 w-100'>
      <SearchOptions {...props} />
    </Grid>
  </div>
)

export const menuItemFilter = ({ position, disabled, type }) =>
  position === 'search' &&
  !disabled &&
  type === 'link'

const SearchOptions = ({ searchType, searchPhrase, ...props }) => {
  const searchOptions = useMenu(selectSearchMenu).filter(({ hideOnSearch }) => !hideOnSearch)

  return searchOptions.map(({ title, activeClass, typeName, icon }) => (
    <SearchOption
      key={typeName}
      {...{
        searchType,
        typeName,
        searchPhrase,
        icon,
        title,
        activeClass,
        ...props
      }}
    />
  ))
}

const SearchOption = ({ searchType, typeName, searchPhrase, icon, title, activeClass, facets, flavour, query, aol, flatFacets, pageNumber }) => {
  const isActive = searchType === typeName

  const isCustomFilter = searchType === 'ca' || searchType === 'precedents'

  return (
    <Grid item xs={12} className='mb4'>
      <SearchTypeButtonContainer
        searchTerm={searchPhrase}
        {...{ title, activeClass }}
        selected={isActive}
        searchType={typeName}
        iconName={icon}
      />
      {((isActive && !isEmpty(facets)) && !isCustomFilter) && (
        <SearchFilters {...{ flavour, searchType, searchPhrase, facets, aol }} />
      )}
      {/* CA filters need to be hard coded */}
      {isActive && searchType === 'ca' && (
        <CaSearchFilters {...{ query, searchType, searchPhrase, aol }} />
      )}
      {(isActive && searchType === 'precedents') && !isEmpty(flatFacets) && (
        <PrecedentsSearchFilters {...{ facets: flatFacets, query, searchType, searchPhrase, aol, flavour, pageNumber }} />
      )}
    </Grid>
  )
}

const CaSearchFilters = ({ query, searchType, searchPhrase, aol }) => {
  const { fromDate, toDate } = query
  const datepicker = useDatePicker(fromDate, toDate)

  const submitDates = (fromDate, toDate) => {
    const getUrl = ({ fromDate, toDate }) => url(SEARCH, { aol, searchType }, { ...query, fromDate, toDate, q: searchPhrase })

    pushEvent({ category: 'Current Awareness', action: 'Filter', label: `Date range from ${fromDate} to ${toDate}` })
    replaceUrl(getUrl({ toDate, fromDate }))
  }

  const onHandleButtonSubmit = () => submitDates(datepicker.fromDateSelected, datepicker.toDateSelected)

  return (
    <div className='mt6 mb4 pa5 pb8 bg-white'>
      {!toDate && !fromDate && (
        <SortBy
          sortingOptions={caSortOptions}
          activeSorting={query.sort}
          urlGenerator={(sort) => url(SEARCH, { aol, searchType }, { ...query, sort })}
        />
      )}
      <FiltersHeader {...{ aol, searchType, searchPhrase, sort: query.sort }} />
      <QuickDatePickers
        toDate={toDate}
        fromDate={fromDate}
        getUrl={(compare) => url(SEARCH, { aol, searchType }, { ...query, ...compare })}
      />
      <CalenderDatePickers
        {...{ onHandleButtonSubmit, ...datepicker, theme: 'ca' }}
      />
    </div>
  )
}

export const FiltersHeader = ({ aol, flavour, searchType, searchPhrase, sort }) => (
  <div className='flex items-center justify-between bb mb4'>
    <h3 className='mb2 f4 fw6 black lh-copy mt4'>
      Filters
    </h3>
    <ResetFilters {...{ aol, flavour, searchType, searchPhrase, sort }} />
  </div>
)

const ResetFilters = ({ aol, flavour, searchType, searchPhrase, sort }) => {
  const href = url(SEARCH, { aol, flavour, searchType }, { q: searchPhrase })
  const className = 'no-underline hover-underline cadet-blue f7 pointer mt6'

  return (
    <a {...{ href, className }}>
      <i>Reset filters</i>
    </a>
  )
}
